import { stagingManager, viewControlInTreatment } from "@/gluelayer"
import { MenuItem, MenuList, Paper } from "@mui/material"
import { FC, useEffect, useState } from "react"
// import DialogBox from "../bottom/DialogBox/dialogBox"
import { UButton } from "@/components/index"
import DialogBox from "@/modules/Clinical/components/DialogBox/dialogBox"

export const UDPonticDomeSelectMenu: FC = () => {
  const allMenuItems = [
    "Contralateral",
    "Duplicate Extraction",
    "Library",
    "Cylinder eruption dome",
    "Flexi-eruption dome",
    "No Pontic/Dome",
  ]
  const [visible, setVisible] = useState(false)
  const [enablePromptForAttachments, setEnablePromptForAttachments] =
    useState(false)
  const [enablePromptForRemoveBiteRamps, setEnablePromptForRemoveBiteRamps] =
    useState(false)
  const [enablePromptForPassiveAligner, setEnablePromptForPassiveAligner] =
    useState(false)
  const [menuInfo, setMenuInfo] = useState({
    menu: [
      {
        index: 0,
        selected: false,
        visiable: false,
      },
    ],
    posx: 0,
    posy: 0,
    toothid: 0,
  })
  const [items, setItems] = useState(allMenuItems)
  const [selectedItem, setSelectedItem] = useState("No Pontic/Dome")

  const onClickItem = (item: string) => {
    console.log("Clicked item:", item)
    setSelectedItem(item)

    if (item === allMenuItems[5]) {
      viewControlInTreatment.DelPonticDome(menuInfo.toothid)
    } else {
      for (let i = 0; i < menuInfo.menu.length; i++) {
        if (item === allMenuItems[menuInfo.menu[i].index]) {
          viewControlInTreatment.AddPonticDome(
            menuInfo.toothid,
            menuInfo.menu[i].index,
          )
          break
        }
      }
    }
  }

  const handleShowDomePonticSelectionMenu = (data) => {
    console.log("ShowDomePonticSelectionMenu:", data)
    setMenuInfo(data)
    setVisible(true)
  }

  const handleHidenDomePonticSelectionMenu = () => {
    setVisible(false)
  }

  const handlePromptHandleDomePontic = (promptType) => {
    console.log("PromptHandleDomePontic:", promptType)
    if (promptType === "for_remove_attachments") {
      setEnablePromptForAttachments(true)
    } else if (promptType === "for_passive_aligner") {
      setEnablePromptForPassiveAligner(true)
    } else if (promptType === "for_remove_bite_ramps") {
      setEnablePromptForRemoveBiteRamps(true)
    }
  }

  useEffect(() => {
    // setSelectedItem(items[menuInfo.menu[0].index])
    let selectedItemString = ""
    let visibleItems = []
    for (const menuItem of menuInfo.menu) {
      if (menuItem.selected) {
        selectedItemString = allMenuItems[menuItem.index]
      }

      if (menuItem.visiable) {
        visibleItems.push(allMenuItems[menuItem.index])
      }
    }
    setItems(visibleItems)
    setSelectedItem(selectedItemString)
  }, [menuInfo])

  useEffect(() => {
    viewControlInTreatment.setShowDomePonticSelectionMenuCallback(
      handleShowDomePonticSelectionMenu,
    )
    viewControlInTreatment.setHidenDomePonticSelectionMenuCallback(
      handleHidenDomePonticSelectionMenu,
    )
    viewControlInTreatment.setPromptHandleDomePonticCallback(
      handlePromptHandleDomePontic,
    )
    // 清理函数
    return () => {
      viewControlInTreatment.setShowDomePonticSelectionMenuCallback(null)
      viewControlInTreatment.setHidenDomePonticSelectionMenuCallback(null)
      viewControlInTreatment.setPromptHandleDomePonticCallback(null)
    }
  }, [])

  return (
    <>
      {visible && (
        <Paper
          elevation={0}
          sx={{
            position: "absolute",
            left: menuInfo.posx,
            top: menuInfo.posy,
            borderRadius: 1,
            overflow: "hidden",
            width: "220px",
          }}
        >
          <MenuList sx={{ padding: 0 }}>
            {items.map((item) => (
              <MenuItem
                key={item}
                onClick={() => onClickItem(item)}
                sx={{
                  width: "220px",
                  height: "50px",
                  padding: "12px 16px",
                  fontSize: 16,
                  fontWeight: selectedItem === item ? 600 : 400,
                  color: selectedItem === item ? "white" : "#464646",
                  border: "1px solid #00000022",
                  borderRadius: "0px",
                  backgroundColor: selectedItem === item ? "#215ECD" : "white",
                  "&:hover": {
                    backgroundColor: selectedItem === item ? "#215ECD" : "white",
                  },
                }}
              >
                {item}
              </MenuItem>
            ))}
          </MenuList>
        </Paper>
      )}

      <DialogBox
        open={enablePromptForAttachments}
        title="Warning"
        content={<>{"Remove all attachments before adding Dome."}</>}
        actions={
          <>
            <UButton
              onClickHandler={() => {
                setEnablePromptForAttachments(false)
              }}
              variant={"text"}
              btnText={"Ok"}
            />
          </>
        }
      ></DialogBox>

      <DialogBox
        open={enablePromptForRemoveBiteRamps}
        title="Warning"
        content={<>{"Remove all BiteRamps before adding Dome."}</>}
        actions={
          <>
            <UButton
              onClickHandler={() => {
                setEnablePromptForRemoveBiteRamps(false)
              }}
              variant={"text"}
              btnText={"Ok"}
            />
          </>
        }
      ></DialogBox>

      <DialogBox
        open={enablePromptForPassiveAligner}
        title="Warning"
        content={
          <>
            {
              "Changes to the tooth movement plan will require new staging of passive aligner."
            }
          </>
        }
        actions={
          <>
            <UButton
              onClickHandler={() => {
                setEnablePromptForPassiveAligner(false)
                stagingManager.delPassiveAligner()
              }}
              variant={"text"}
              btnText={"Ok"}
            />
            <UButton
              onClickHandler={() => {
                setEnablePromptForPassiveAligner(false)
              }}
              variant={"text"}
              btnText={"Cancel"}
            />
          </>
        }
      ></DialogBox>
    </>
  )
}
